import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

// Page-level code splitting — each page loads only when navigated to
const Home           = lazy(() => import('../pages/home/page'));
const About          = lazy(() => import('../pages/about/page'));
const Services       = lazy(() => import('../pages/services/page'));
const RevenueSharing = lazy(() => import('../pages/revenue-sharing/page'));
const Join           = lazy(() => import('../pages/join/page'));
const Contact        = lazy(() => import('../pages/contact/page'));
const Partnership    = lazy(() => import('../pages/partnership/page'));
const Admin          = lazy(() => import('../pages/admin/page'));
const Privacy        = lazy(() => import('../pages/privacy/page'));
const Terms          = lazy(() => import('../pages/terms/page'));

// Minimal full-page loading fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-4 border-gray-100 border-t-red-600 rounded-full animate-spin"></div>
      <p className="text-gray-400 text-sm font-medium">Loading...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<PageLoader />}><Home /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<PageLoader />}><About /></Suspense>,
  },
  {
    path: '/services',
    element: <Suspense fallback={<PageLoader />}><Services /></Suspense>,
  },
  {
    path: '/revenue-sharing',
    element: <Suspense fallback={<PageLoader />}><RevenueSharing /></Suspense>,
  },
  {
    path: '/join',
    element: <Suspense fallback={<PageLoader />}><Join /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<PageLoader />}><Contact /></Suspense>,
  },
  {
    path: '/partnership',
    element: <Suspense fallback={<PageLoader />}><Partnership /></Suspense>,
  },
  {
    path: '/admin',
    element: <Suspense fallback={<PageLoader />}><Admin /></Suspense>,
  },
  {
    path: '/privacy',
    element: <Suspense fallback={<PageLoader />}><Privacy /></Suspense>,
  },
  {
    path: '/terms',
    element: <Suspense fallback={<PageLoader />}><Terms /></Suspense>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
